import tw from "twin.macro";
export const PrimaryButton = tw.button`px-8 py-3 font-bold rounded bg-[#0049AC] text-gray-100 focus:shadow-outline focus:outline-none transition duration-300`;
